import { useWindowWidth } from "@react-hook/window-size";

export const useIsMobile = () => useWindowWidth() < 800;
